import axios from 'axios';
import { configRefs } from '@utils/constants';

async function createTeamRequest(user, team) {
  if (!user) {
    throw new Error("createTeamRequest(): A logged in user must be provided when creating teams!");
  }
  const teamDTO = {
    userID: user.id,
    userInstitutionID: user.institution?.id,
    enableNotifications: team.enabledNotifications,
    title: team.title,
    subjects: team.subjects,
    teams: team.teams
  };
  const res = await axios.post(`${await configRefs.apis.userdata.get()}/api/Filters?userID=${user.id}`, teamDTO);
  return {
    ...team,
    id: res.data.objectID
  };
}

export { createTeamRequest };
//# sourceMappingURL=api.create-team.request.js.map
